import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  updateProfile: (customerId, data) => api.put(`/auth/profile/${customerId}`, data),
  requestPasswordReset: (email) => api.post('/auth/reset-password-request', { email }),
  resetPassword: (token, newPassword) => api.post('/auth/reset-password', { token, new_password: newPassword }),
  verifyResetToken: (token) => api.get('/auth/verify-reset-token', { params: { token } }),
};

// Customer APIs
export const customerAPI = {
  list: (params) => api.get('/customers', { params }),
  get: (id) => api.get(`/customers/${id}`),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  lookup: (identifier) => api.post('/customers/lookup', { identifier }),
  checkin: (identifier) => api.post('/customers/checkin', { identifier }),
};

// Promotion APIs
export const promotionAPI = {
  create: (data) => api.post('/promotions', data),
  list: (activeOnly = true) => api.get('/promotions', { params: { active_only: activeOnly } }),
  get: (id) => api.get(`/promotions/${id}`),
  update: (id, data) => api.put(`/promotions/${id}`, data),
  delete: (id) => api.delete(`/promotions/${id}`),
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/promotion-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

// Reward APIs
export const rewardAPI = {
  create: (data) => api.post('/rewards', data),
  list: (activeOnly = true) => api.get('/rewards', { params: { active_only: activeOnly } }),
  get: (id) => api.get(`/rewards/${id}`),
  update: (id, data) => api.put(`/rewards/${id}`, data),
  delete: (id) => api.delete(`/rewards/${id}`),
  redeem: (customerId, rewardId) => api.post('/rewards/redeem', { customer_id: customerId, reward_id: rewardId }),
  convertStickers: (customerId) => api.post('/rewards/convert-stickers', { customer_id: customerId }),
  requestRedemption: (customerId, rewardId, redemptionType = 'reward') => 
    api.post('/rewards/request-redemption', { customer_id: customerId, reward_id: rewardId, redemption_type: redemptionType }),
  cancelRedemption: (customerId) => api.delete(`/rewards/cancel-redemption/${customerId}`),
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/reward-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

// Cashier APIs
export const cajaAPI = {
  verifyCode: (code) => api.post('/caja/verify-code', { code }),
  confirmRedemption: (code) => api.post('/caja/confirm-redemption', { code }),
};

// Admin APIs
export const adminAPI = {
  getStats: () => api.get('/admin/stats'),
  getOdooStatus: () => api.get('/odoo/status'),
  syncCustomerToOdoo: (customerId) => api.post(`/odoo/sync/${customerId}`),
  createCustomer: (data) => api.post('/admin/customers', data),
  updateStickers: (customerId, data) => api.put(`/admin/customers/${customerId}/visits`, data),
  deleteCustomer: (customerId) => api.delete(`/admin/customers/${customerId}`),
  getArchivedCustomers: () => api.get('/admin/customers/archived'),
  restoreCustomer: (odooPartnerId, { password = '1234', stickers = 0, gold_coins = 0 } = {}) => 
    api.post(`/admin/customers/restore/${odooPartnerId}`, null, { 
      params: { password, stickers, gold_coins } 
    }),
  // Admin Authentication
  login: (data) => api.post('/admin/auth/login', data),
  verify: (adminId) => api.get('/admin/auth/verify', { params: { admin_id: adminId } }),
  // Admin Management (requires admin role)
  listAdmins: (adminId) => api.get('/admin/admins', { params: { requesting_admin_id: adminId } }),
  createAdmin: (data, adminId) => api.post('/admin/admins', data, { params: { requesting_admin_id: adminId } }),
  deleteAdmin: (targetAdminId, adminId) => api.delete(`/admin/admins/${targetAdminId}`, { params: { requesting_admin_id: adminId } }),
  // Odoo POS Sync
  syncPOS: () => api.post('/odoo/sync-pos'),
  getSyncStatus: () => api.get('/odoo/sync-status'),
};

// Health check
export const healthCheck = () => api.get('/health');

export default api;
